export default __webpack_public_path__ + "static/media/Grips of the Refectory.53950932.jpg";